import React from 'react'
import { connect } from 'react-redux'
import { Row, Col, Card, Button } from 'react-bootstrap'

const ChartFormPhase = (props) => {

  const {
    title,
    chartForReview,
    chartForRevision,
    chartForm,
    chartReviewNotes,
    notesSection,
    notesAreReadOnly,
    showChartReviewNotesModal,
    toggleShowChartReviewNotesModal,
  } = props

  const getSingularOrPluralNotesText = (notesArray) => {
    if (!notesArray || notesArray.length === 0) {
      return 'No notes for this section'
    } else if (notesArray.length === 1) {
      return `There is ${notesArray.length} note for this section.`
    } else {
      return `There are ${notesArray.length} notes for this section.`
    }
  }

  const createRevisionNotesText = () => {
    const thereAreAdverseEventNotes = chartReviewNotes && chartReviewNotes['ADR'] && Object.keys(chartReviewNotes['ADR']).length > 0

    if (notesSection === 'Antibiotics' && thereAreAdverseEventNotes) {
      return (
        <>
          <span>
            {getSingularOrPluralNotesText(chartReviewNotes[notesSection])}
          </span>
          <br/>
          <h5>
            ADR Notes:
          </h5>
          {Object.keys(chartReviewNotes['ADR']).map(adverseEvent => {
            return (
              <span key={adverseEvent}>
                <strong>
                  {adverseEvent}:
                </strong>{' '}
                {chartReviewNotes['ADR'][adverseEvent] ?
                  getSingularOrPluralNotesText(chartReviewNotes['ADR'][adverseEvent].notes)
                  :
                  'No notes for this section'
                }
              </span>
            )
          })}
          <br/>
          <span>
            Click the 'Show Notes' button to view.
          </span>
        </>
      )
    }

    return `${getSingularOrPluralNotesText(chartReviewNotes[notesSection])} Click the 'Show Notes' button to view.`
  }

  return (
    <div>
      <Row className='sticky'>
        <Col xs={12} sm={12} md={8} lg={9}>
          <h4 style={{paddingTop: '5px'}}>
            {title}
          </h4>
        </Col>
        {chartForReview || chartForRevision || notesAreReadOnly ?
          <Col xs={0} sm={0} md={4} lg={3}>
            <Button onClick={() => toggleShowChartReviewNotesModal(!showChartReviewNotesModal)} style={{ width: '100%' }}>
              {props.chartForReview ?
                'Create or View All Notes'
                :
                'View All Notes'
              }
            </Button>
          </Col>
          :
          null
        }
      </Row>

      <br/>

      {chartForRevision || notesAreReadOnly ?
        <Card className='chart-revision-notes-card' border='danger'>
          <h5>
            Revision Notes:
          </h5>
          {createRevisionNotesText()}
        </Card>
        :
        null
      }
      {chartForm}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    chartReviewNotes: state.chartNotesReducer.chartReviewNotes,
  }
}

export default connect(mapStateToProps)(ChartFormPhase)
